import { LoginFormPage, ProFormText } from "@ant-design/pro-components";
import { message } from "antd";
import { AxiosError } from "axios";
import { LoginRequest } from "../types";
import logoImage from "../../shared/images/c1-logo-dark.svg";
import { login } from "../helper-methods";
import "./login-page.scss";

export const LoginPage = () => {
  const onFinish = async (data: LoginRequest) => {
    try {
      await login(data);
      messageApi.success("Login Successful");
    } catch (e) {
      if (e instanceof AxiosError && e.response?.status === 400) {
        messageApi.error("Invalid username or password");
      } else {
        messageApi.error("Something went wrong. Please try again.");
      }
    }
  };

  const [messageApi, contextHolder] = message.useMessage();

  return (
    <div className="bg-white w-full">
      <LoginFormPage<LoginRequest>
        onFinish={onFinish}
        style={{
          height: "100vh",
          backgroundRepeat: "no-repeat",
          backgroundSize: "70%",
          backgroundPosition: "center",
          color: "#fff",
        }}
        logo={logoImage}
        // actions={
        //   <Button
        //     onClick={() => window.location.replace("./")}
        //     className="w-full mt-2"
        //     size="middle"
        //   >
        //     Go To Survey Page
        //   </Button>
        // }
        title="Login"
        subTitle="Login to continue to your account"
        backgroundImageUrl="/c1-logo-bg.png"
      >
        {contextHolder}
        <ProFormText
          name="username"
          label="Username"
          placeholder="Username"
          required
          rules={[{ required: true, message: "Username is required" }]}
        />
        <ProFormText.Password
          name="password"
          label="Password"
          required
          rules={[{ required: true, message: "Password is required" }]}
        />
      </LoginFormPage>
    </div>
  );
};
